export const productsData = {
  4548076097167: {
    code: '4548076097167',
    name: '男棉米蘭諾羅紋有領開襟衫',
    description: '',
    price: '2,790',
    alt: '黑色',
  },
  4548076097204: {
    code: '4548076097204',
    name: '男棉米蘭諾羅紋有領開襟衫',
    description: '',
    price: '2,790',
    alt: '淺米',
  },
  4548076097600: {
    code: '4548076097600',
    name: '男棉米蘭諾羅紋針織舒適長褲',
    description: '',
    price: '2,790',
    alt: '墨灰',
  },
  4548076097648: {
    code: '4548076097648',
    name: '男棉米蘭諾羅紋針織舒適長褲',
    description: '',
    price: '2,790',
    alt: '黑色',
  },
  4548076097686: {
    code: '4548076097686',
    name: '男棉米蘭諾羅紋針織舒適長褲',
    description: '',
    price: '2,790',
    alt: '淺米',
  },
  4548076097365: {
    code: '4548076097365',
    name: '男強撚棉粗織長袖針織衫',
    description: '',
    price: '2,190',
    alt: '黑色',
  },
  4548076097402: {
    code: '4548076097402',
    name: '男強撚棉粗織長袖針織衫',
    description: '',
    price: '2,190',
    alt: '米黃',
  },
  4548076097440: {
    code: '4548076097440',
    name: '男強撚棉粗織長袖針織衫',
    description: '',
    price: '2,190',
    alt: '深藍',
  },
  4548076094661: {
    code: '4548076094661',
    name: '女棉混毛絨圓領針織衫',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076094708: {
    code: '4548076094708',
    name: '女棉混毛絨圓領針織衫',
    description: '',
    price: '1,990',
    alt: '象牙白',
  },
  4548076094746: {
    code: '4548076094746',
    name: '女棉混毛絨圓領針織衫',
    description: '',
    price: '1,990',
    alt: '深藍',
  },
  4548076094869: {
    code: '4548076094869',
    name: '女棉混毛絨針織外套',
    description: '',
    price: '2,190',
    alt: '淺灰',
  },
  4548076094906: {
    code: '4548076094906',
    name: '女棉混毛絨針織外套',
    description: '',
    price: '2,190',
    alt: '深灰',
  },
  4548076095026: {
    code: '4548076095026',
    name: '女棉混毛絨五分袖針織衫',
    description: '',
    price: '1,790',
    alt: '淺灰',
  },
  4548076095064: {
    code: '4548076095064',
    name: '女棉混毛絨五分袖針織衫',
    description: '',
    price: '1,790',
    alt: '深藍',
  },
  4548076105107: {
    code: '4548076105107',
    name: '男傳統編織天竺圓領短袖T恤',
    description: '',
    price: '790',
    alt: '白色',
  },
  4548076105145: {
    code: '4548076105145',
    name: '男傳統編織天竺圓領短袖T恤',
    description: '',
    price: '790',
    alt: '黑色',
  },
  4548076105985: {
    code: '4548076105985',
    name: '男傳統編織天竺圓領短袖T恤',
    description: '',
    price: '790',
    alt: '米黃',
  },
  4548076878032: {
    code: '4548076878032',
    name: '男傳統編織天竺圓領短袖T恤',
    description: '',
    price: '790',
    alt: '煙燻紫',
  },
  4548076106159: {
    code: '4548076106159',
    name: '男傳統編織迷你裏毛圓領長袖T恤',
    description: '',
    price: '1,190',
    alt: '淺灰',
  },
  4548076106197: {
    code: '4548076106197',
    name: '男傳統編織迷你裏毛圓領長袖T恤',
    description: '',
    price: '1,190',
    alt: '墨灰',
  },
  4548076106241: {
    code: '4548076106241',
    name: '男傳統編織迷你裏毛圓領長袖T恤',
    description: '',
    price: '1,190',
    alt: '暗藍',
  },
  4548076106401: {
    code: '4548076106401',
    name: '男傳統編織裏毛連帽外套',
    description: '',
    price: '1,790',
    alt: '灰色',
  },
  4548076106500: {
    code: '4548076106500',
    name: '男傳統編織裏毛連帽外套',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076106548: {
    code: '4548076106548',
    name: '男傳統編織裏毛連帽外套',
    description: '',
    price: '1,790',
    alt: '暗藍',
  },
  4548076106708: {
    code: '4548076106708',
    name: '男傳統編織迷你裏毛圓領短袖T恤',
    description: '',
    price: '990',
    alt: '白色',
  },
  4548076106746: {
    code: '4548076106746',
    name: '男傳統編織迷你裏毛圓領短袖T恤',
    description: '',
    price: '990',
    alt: '淺灰',
  },
  4548076106784: {
    code: '4548076106784',
    name: '男傳統編織迷你裏毛圓領短袖T恤',
    description: '',
    price: '990',
    alt: '墨灰',
  },
  4548076162049: {
    code: '4548076162049',
    name: '女府綢寬鬆長版衫',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076162100: {
    code: '4548076162100',
    name: '女府綢寬鬆長版衫',
    description: '',
    price: '1,990',
    alt: '淺灰直紋',
  },
  4548076162148: {
    code: '4548076162148',
    name: '女府綢寬鬆長版衫',
    description: '',
    price: '1,990',
    alt: '淺藍直紋',
  },
  4548076162308: {
    code: '4548076162308',
    name: '女府綢襯衫式洋裝',
    description: '',
    price: '2,590',
    alt: '深灰',
  },
  4548076162346: {
    code: '4548076162346',
    name: '女府綢襯衫式洋裝',
    description: '',
    price: '2,590',
    alt: '淡藍',
  },
  4548076162384: {
    code: '4548076162384',
    name: '女府綢襯衫式洋裝',
    description: '',
    price: '2,590',
    alt: '深藍直紋',
  },
  4548076162582: {
    code: '4548076162582',
    name: '女府綢短袖襯衫',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076162629: {
    code: '4548076162629',
    name: '女府綢短袖襯衫',
    description: '',
    price: '1,990',
    alt: '深灰',
  },
  4548076162667: {
    code: '4548076162667',
    name: '女府綢短袖襯衫',
    description: '',
    price: '1,990',
    alt: '淡綠',
  },
  4548076162704: {
    code: '4548076162704',
    name: '女府綢短袖襯衫',
    description: '',
    price: '1,990',
    alt: '淡藍',
  },
  4548076841722: {
    code: '4548076841722',
    name: '男棉工作襯衫',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076841760: {
    code: '4548076841760',
    name: '男棉工作襯衫',
    description: '',
    price: '1,990',
    alt: '灰色',
  },
  4548076841838: {
    code: '4548076841838',
    name: '男棉工作襯衫',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076844792: {
    code: '4548076844792',
    name: '女棉寬鬆襯衫',
    description: '',
    price: '2,590',
    alt: '柔白',
  },
  4548076844839: {
    code: '4548076844839',
    name: '女棉寬鬆襯衫',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076165590: {
    code: '4548076165590',
    name: '男再生聚酯纖維丹寧外套',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076165637: {
    code: '4548076165637',
    name: '男再生聚酯纖維丹寧外套',
    description: '',
    price: '2,590',
    alt: '暗藍',
  },
  4548076164203: {
    code: '4548076164203',
    name: '男透氣撥水加工棉混尼龍連帽外套',
    description: '',
    price: '3,590',
    alt: '黑色',
  },
  4548076164906: {
    code: '4548076164906',
    name: '男透氣撥水加工棉混尼龍連帽外套',
    description: '',
    price: '3,590',
    alt: '煙燻紫',
  },
  4548076171706: {
    code: '4548076171706',
    name: '女高密度棉單排扣大衣',
    description: '',
    price: '4,590',
    alt: '黑色',
  },
  4548076171744: {
    code: '4548076171744',
    name: '女高密度棉單排扣大衣',
    description: '',
    price: '4,590',
    alt: '米色',
  },
  4548076171782: {
    code: '4548076171782',
    name: '女高密度棉單排扣大衣',
    description: '',
    price: '4,590',
    alt: '卡其',
  },
  4548076165804: {
    code: '4548076165804',
    name: '男嫘縈混棉短版外套',
    description: '',
    price: '3,590',
    alt: '黑色',
  },
  4548076165842: {
    code: '4548076165842',
    name: '男嫘縈混棉短版外套',
    description: '',
    price: '3,590',
    alt: '象牙白',
  },
  4548076165880: {
    code: '4548076165880',
    name: '男嫘縈混棉短版外套',
    description: '',
    price: '3,590',
    alt: '黑色x柔白色',
  },
  4548076169604: {
    code: '4548076169604',
    name: '女嫘縈混棉有領短版外套',
    description: '',
    price: '3,190',
    alt: '黑色',
  },
  4548076169642: {
    code: '4548076169642',
    name: '女嫘縈混棉有領短版外套',
    description: '',
    price: '3,190',
    alt: '象牙白',
  },
  4548076163176: {
    code: '4548076163176',
    name: '男輕量棉帆布連帽外套',
    description: '',
    price: '4,590',
    alt: '黑色',
  },
  4548076163213: {
    code: '4548076163213',
    name: '男輕量棉帆布連帽外套',
    description: '',
    price: '4,590',
    alt: '米黃',
  },
  4548076166054: {
    code: '4548076166054',
    name: '女輕量棉帆布連帽外套',
    description: '',
    price: '3,190',
    alt: '墨灰',
  },
  4548076166962: {
    code: '4548076166962',
    name: '女輕量棉帆布連帽外套',
    description: '',
    price: '3,190',
    alt: '黑色',
  },
  4548076169000: {
    code: '4548076169000',
    name: '女輕量棉帆布連帽外套',
    description: '',
    price: '3,190',
    alt: '米黃',
  },
  4548076170815: {
    code: '4548076170815',
    name: '女再生聚酯纖維丹寧桶型褲',
    description: '',
    price: '2,590',
    alt: '暗藍',
  },
  4548076172062: {
    code: '4548076172062',
    name: '男再生聚酯纖維丹寧工作褲',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076172109: {
    code: '4548076172109',
    name: '男再生聚酯纖維丹寧工作褲',
    description: '',
    price: '2,590',
    alt: '暗藍',
  },
  4548076170365: {
    code: '4548076170365',
    name: '男再生棉膝蓋補強褲',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076169840: {
    code: '4548076169840',
    name: '男棉帆布膝蓋補強褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076169888: {
    code: '4548076169888',
    name: '男棉帆布膝蓋補強褲',
    description: '',
    price: '1,990',
    alt: '煙燻紫',
  },
  4548076170648: {
    code: '4548076170648',
    name: '女棉帆布打褶桶型褲',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076170686: {
    code: '4548076170686',
    name: '女棉帆布打褶桶型褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076170723: {
    code: '4548076170723',
    name: '女棉帆布打褶桶型褲',
    description: '',
    price: '1,990',
    alt: '煙燻紫',
  },
  4548076845379: {
    code: '4548076845379',
    name: '女棉混打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '柔白',
  },
  4548076845430: {
    code: '4548076845430',
    name: '女棉混打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '深灰',
  },
  4548076845492: {
    code: '4548076845492',
    name: '女棉混打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076845553: {
    code: '4548076845553',
    name: '女棉混打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '米色',
  },
  4548076170044: {
    code: '4548076170044',
    name: '男輕量棉帆布舒適工作褲',
    description: '',
    price: '1,990',
    alt: '墨灰',
  },
  4548076170082: {
    code: '4548076170082',
    name: '男輕量棉帆布舒適工作褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076170129: {
    code: '4548076170129',
    name: '男輕量棉帆布舒適工作褲',
    description: '',
    price: '1,990',
    alt: '米黃',
  },
  4548076170938: {
    code: '4548076170938',
    name: '女棉輕量棉帆布抽繩褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076170976: {
    code: '4548076170976',
    name: '女棉輕量棉帆布抽繩褲',
    description: '',
    price: '1,990',
    alt: '米黃',
  },
  4550723053778: {
    code: '4550723053778',
    name: '再生尼龍迷你波士頓包',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4550723053785: {
    code: '4550723053785',
    name: '撥水加工兩用包',
    description: '',
    price: '1,990',
    alt: '卡其',
  },
  4550723053792: {
    code: '4550723053792',
    name: '撥水加工兩用包',
    description: '',
    price: '1,990',
    alt: '暗藍',
  },
  4550723053808: {
    code: '4550723053808',
    name: '撥水加工兩用包',
    description: '',
    price: '1,990',
    alt: '棕色',
  },
  4550723053815: {
    code: '4550723053815',
    name: '撥水加工兩用包/小',
    description: '',
    price: '1,390',
    alt: '卡其',
  },
  4550723053822: {
    code: '4550723053822',
    name: '撥水加工兩用包/小',
    description: '',
    price: '1,390',
    alt: '暗藍',
  },
  4550723053839: {
    code: '4550723053839',
    name: '撥水加工兩用包/小',
    description: '',
    price: '1,390',
    alt: '棕色',
  },
  4548076119999: {
    code: '4548076119999',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076120049: {
    code: '4548076120049',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '深灰',
  },
  4548076120094: {
    code: '4548076120094',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076120612: {
    code: '4548076120612',
    name: '男棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076120650: {
    code: '4548076120650',
    name: '男棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '深灰',
  },
  4548076120759: {
    code: '4548076120759',
    name: '男棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076120872: {
    code: '4548076120872',
    name: '女棉天竺寬鬆舒適長褲',
    description: '',
    price: '990',
    alt: '深灰',
  },
  4548076120919: {
    code: '4548076120919',
    name: '女棉天竺寬鬆舒適長褲',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076121114: {
    code: '4548076121114',
    name: '柔滑針織短袖套衫',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076121169: {
    code: '4548076121169',
    name: '柔滑針織短袖套衫',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076121237: {
    code: '4548076121237',
    name: '柔滑針織短袖套衫',
    description: '',
    price: '990',
    alt: '米黃',
  },
  4548076121985: {
    code: '4548076121985',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '深灰',
  },
  4548076122036: {
    code: '4548076122036',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076122081: {
    code: '4548076122081',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '米黃',
  },
  4548076835233: {
    code: '4548076835233',
    name: '女棉混強撚針織短袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076835271: {
    code: '4548076835271',
    name: '女棉混強撚針織短袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076835370: {
    code: '4548076835370',
    name: '女棉混強撚針織短袖T恤',
    description: '',
    price: '990',
    alt: '深藍',
  },
  4548076835493: {
    code: '4548076835493',
    name: '女棉混強撚針織坦克背心',
    description: '',
    price: '790',
    alt: '柔白',
  },
  4548076835592: {
    code: '4548076835592',
    name: '女棉混強撚針織坦克背心',
    description: '',
    price: '790',
    alt: '黑色',
  },
  4548076835752: {
    code: '4548076835752',
    name: '女棉混強撚針織背心',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076835790: {
    code: '4548076835790',
    name: '女棉混強撚針織背心',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076835837: {
    code: '4548076835837',
    name: '女棉混強撚針織背心',
    description: '',
    price: '990',
    alt: '深藍',
  },
  4548076834090: {
    code: '4548076834090',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '柔白',
  },
  4548076834137: {
    code: '4548076834137',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '灰色',
  },
  4548076834175: {
    code: '4548076834175',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '淡綠',
  },
  4548076834496: {
    code: '4548076834496',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
  },
  4548076834533: {
    code: '4548076834533',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '淺灰',
  },
  4548076834571: {
    code: '4548076834571',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4548076834618: {
    code: '4548076834618',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '淡綠',
  },
  4548076107200: {
    code: '4548076107200',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '白色',
  },
  4548076107248: {
    code: '4548076107248',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076107286: {
    code: '4548076107286',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '灰棕',
  },
  4548076107477: {
    code: '4548076107477',
    name: '女和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '柔白',
  },
  4548076107590: {
    code: '4548076107590',
    name: '女和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076107637: {
    code: '4548076107637',
    name: '女和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '淺粉',
  },
  4548076841524: {
    code: '4548076841524',
    name: '男亞麻混萊賽爾拉鍊工裝襯衫',
    description: '',
    price: '3,190',
    alt: '黑色',
  },
  4548076841562: {
    code: '4548076841562',
    name: '男亞麻混萊賽爾拉鍊工裝襯衫',
    description: '',
    price: '3,190',
    alt: '卡其',
  },
  4548076843474: {
    code: '4548076843474',
    name: '男亞麻混萊賽爾舒適長褲',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076843511: {
    code: '4548076843511',
    name: '男亞麻混萊賽爾舒適長褲',
    description: '',
    price: '2,590',
    alt: '卡其',
  },
  4548076843559: {
    code: '4548076843559',
    name: '男亞麻混萊賽爾舒適長褲',
    description: '',
    price: '2,590',
    alt: '煙燻紫',
  },
  4548076843252: {
    code: '4548076843252',
    name: '女亞麻混萊賽爾短版外套',
    description: '',
    price: '3,190',
    alt: '黑色',
  },
  4548076843290: {
    code: '4548076843290',
    name: '女亞麻混萊賽爾短版外套',
    description: '',
    price: '3,190',
    alt: '卡其',
  },
  4548076844204: {
    code: '4548076844204',
    name: '女亞麻混萊賽爾打褶寬版褲',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076844273: {
    code: '4548076844273',
    name: '女亞麻混萊賽爾打褶寬版褲',
    description: '',
    price: '2,590',
    alt: '卡其',
  },
  4548076844396: {
    code: '4548076844396',
    name: '女亞麻混萊賽爾舒適打褶裙',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076844433: {
    code: '4548076844433',
    name: '女亞麻混萊賽爾舒適打褶裙',
    description: '',
    price: '2,590',
    alt: '卡其',
  },
  4548076169727: {
    code: '4548076169727',
    name: '女亞麻混棉人字紋短版外套',
    description: '',
    price: '3,190',
    alt: '灰色',
  },
  4548076172185: {
    code: '4548076172185',
    name: '女亞麻混棉人字紋打褶寬版褲',
    description: '',
    price: '2,590',
    alt: '灰色',
  },
  4550723087346: {
    code: '4550723087346',
    name: '帆布低筒休閒鞋',
    description: '',
    price: '4,990',
    alt: '灰色',
  },
  4550723087407: {
    code: '4550723087407',
    name: '帆布低筒休閒鞋',
    description: '',
    price: '4,990',
    alt: '象牙白',
  },
  4550723087452: {
    code: '4550723087452',
    name: '帆布低筒休閒鞋',
    description: '',
    price: '4,990',
    alt: '灰色',
  },
  4550723087506: {
    code: '4550723087506',
    name: '帆布低筒休閒鞋',
    description: '',
    price: '4,990',
    alt: '象牙白',
  },
  4550723053846: {
    code: '4550723053846',
    name: '手工編織馬尼拉麻托特包',
    description: '',
    price: '2,990',
    alt: '黑色',
  },
  4550723053853: {
    code: '4550723053853',
    name: '手工編織馬尼拉麻托特包',
    description: '',
    price: '2,990',
    alt: '棕色',
  },
  4550723056250: {
    code: '4550723056250',
    name: '橄欖萃取革無孔皮帶',
    description: '',
    price: '1,190',
    alt: '白色',
  },
  4550723056267: {
    code: '4550723056267',
    name: '橄欖萃取革無孔皮帶',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4548076834977: {
    code: '4548076834977',
    name: '高島縮織舒適長褲',
    description: '',
    price: '1,990',
    alt: '灰白',
  },
  4548076835028: {
    code: '4548076835028',
    name: '高島縮織舒適長褲',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076835073: {
    code: '4548076835073',
    name: '高島縮織舒適長褲',
    description: '',
    price: '1,990',
    alt: '暗藍',
  },
  4548076841999: {
    code: '4548076841999',
    name: '男天然素材染色短袖襯衫',
    description: '',
    price: '1,990',
    alt: '灰色',
  },
  4548076842033: {
    code: '4548076842033',
    name: '男天然素材染色短袖襯衫',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076842071: {
    code: '4548076842071',
    name: '男天然素材染色短袖襯衫',
    description: '',
    price: '1,990',
    alt: '米色',
  },
  4548076169123: {
    code: '4548076169123',
    name: '女天然素材染色工裝外套',
    description: '',
    price: '4,590',
    alt: '黑色',
  },
  4548076169161: {
    code: '4548076169161',
    name: '女天然素材染色工裝外套',
    description: '',
    price: '4,590',
    alt: '煙燻藍',
  },
  4548076844006: {
    code: '4548076844006',
    name: '男天然素材染色短褲',
    description: '',
    price: '1,590',
    alt: '灰色',
  },
  4548076844044: {
    code: '4548076844044',
    name: '男天然素材染色短褲',
    description: '',
    price: '1,590',
    alt: '黑色',
  },
  4548076844082: {
    code: '4548076844082',
    name: '男天然素材染色短褲',
    description: '',
    price: '1,590',
    alt: '米色',
  },
  4548076094425: {
    code: '4548076094425',
    name: '男和紙混圓領短袖針織衫',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076094463: {
    code: '4548076094463',
    name: '男和紙混圓領短袖針織衫',
    description: '',
    price: '1,790',
    alt: '米黃',
  },
  4548076094500: {
    code: '4548076094500',
    name: '男和紙混圓領短袖針織衫',
    description: '',
    price: '1,790',
    alt: '淡綠',
  },
  4548076095224: {
    code: '4548076095224',
    name: '女和紙混長袖圓領針織衫',
    description: '',
    price: '1,990',
    alt: '墨灰',
  },
  4548076095262: {
    code: '4548076095262',
    name: '女和紙混長袖圓領針織衫',
    description: '',
    price: '1,990',
    alt: '象牙白',
  },
  4548076095309: {
    code: '4548076095309',
    name: '女和紙混長袖圓領針織衫',
    description: '',
    price: '1,990',
    alt: '淡綠',
  },
  4548076095460: {
    code: '4548076095460',
    name: '女和紙混無袖針織衫',
    description: '',
    price: '1,390',
    alt: '墨灰',
  },
  4548076095590: {
    code: '4548076095590',
    name: '女和紙混無袖針織衫',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076096795: {
    code: '4548076096795',
    name: '女和紙混無袖針織衫',
    description: '',
    price: '1,390',
    alt: '象牙白',
  },
  4548076842323: {
    code: '4548076842323',
    name: '男和紙混多臂織短袖襯衫',
    description: '',
    price: '1,990',
    alt: '墨灰',
  },
  4548076842361: {
    code: '4548076842361',
    name: '男和紙混多臂織短袖襯衫',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4548076842408: {
    code: '4548076842408',
    name: '男和紙混多臂織短袖襯衫',
    description: '',
    price: '1,990',
    alt: '暗藍',
  },
  4548076843733: {
    code: '4548076843733',
    name: '男和紙混多臂織舒適長褲',
    description: '',
    price: '2,590',
    alt: '墨灰',
  },
  4548076843771: {
    code: '4548076843771',
    name: '男和紙混多臂織舒適長褲',
    description: '',
    price: '2,590',
    alt: '黑色',
  },
  4548076843818: {
    code: '4548076843818',
    name: '男和紙混多臂織舒適長褲',
    description: '',
    price: '2,590',
    alt: '暗藍',
  },
  4548076845003: {
    code: '4548076845003',
    name: '女和紙混多臂織短褲',
    description: '',
    price: '1,990',
    alt: '淺灰',
  },
  4548076845041: {
    code: '4548076845041',
    name: '女和紙混多臂織短褲',
    description: '',
    price: '1,990',
    alt: '墨灰',
  },
  4548076845089: {
    code: '4548076845089',
    name: '女和紙混多臂織短褲',
    description: '',
    price: '1,990',
    alt: '暗藍',
  },
  4548076842521: {
    code: '4548076842521',
    name: '女和紙混籃紋織無袖套衫',
    description: '',
    price: '1,190',
    alt: '柔白',
  },
  4548076842569: {
    code: '4548076842569',
    name: '女和紙混籃紋織無袖套衫',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4548076842729: {
    code: '4548076842729',
    name: '女和紙混籃紋織短袖套衫',
    description: '',
    price: '1,790',
    alt: '柔白',
  },
  4548076842767: {
    code: '4548076842767',
    name: '女和紙混籃紋織短袖套衫',
    description: '',
    price: '1,790',
    alt: '深灰',
  },
  4548076842804: {
    code: '4548076842804',
    name: '女和紙混籃紋織短袖套衫',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076842965: {
    code: '4548076842965',
    name: '女和紙混高密度府綢無袖抓皺洋裝',
    description: '',
    price: '3,190',
    alt: '淺灰',
  },
  4548076843092: {
    code: '4548076843092',
    name: '女和紙混高密度府綢無袖抓皺洋裝',
    description: '',
    price: '3,190',
    alt: '灰色',
  },
  4548076843139: {
    code: '4548076843139',
    name: '女和紙混高密度府綢無袖抓皺洋裝',
    description: '',
    price: '3,190',
    alt: '黑色',
  },
  4548076844600: {
    code: '4548076844600',
    name: '女和紙混高密度府綢打褶裙',
    description: '',
    price: '3,590',
    alt: '灰色',
  },
  4548076844662: {
    code: '4548076844662',
    name: '女和紙混高密度府綢打褶裙',
    description: '',
    price: '3,590',
    alt: '黑色',
  },
  4548076845676: {
    code: '4548076845676',
    name: '女和紙混高密度府綢附內裏打褶裙',
    description: '',
    price: '3,190',
    alt: '柔白',
  },
  4548076120407: {
    code: '4548076120407',
    name: '手紡手織家居睡衣',
    description: '',
    price: '2,990',
    alt: '黑色',
  },
  4548076120452: {
    code: '4548076120452',
    name: '手紡手織家居睡衣',
    description: '',
    price: '2,990',
    alt: '卡其',
  },
  // 女皮革低筒休閒鞋
  4547315579594: {
    code: '4547315579594',
    name: '女皮革低筒休閒鞋',
    description: '',
    price: '5,590',
    alt: '白色',
  },
  4547315579648: {
    code: '4547315579648',
    name: '女皮革低筒休閒鞋',
    description: '',
    price: '5,590',
    alt: '黑色',
  },
  // 男皮革低筒休閒鞋
  4547315579471: {
    code: '4547315579471',
    name: '男皮革低筒休閒鞋',
    description: '',
    price: '5,590',
    alt: '白色',
  },
  4547315579532: {
    code: '4547315579532',
    name: '男皮革低筒休閒鞋',
    description: '',
    price: '5,590',
    alt: '黑色',
  },
};

export const lookData = [
  {
    id: 1,
    layout: '01',
    images: ['01-look-01', '01-look-02', '01-look-03', '01-look-04'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076163176', '4548076163213'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170365'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4547315579471', '4547315579532'],
          },
        ],
      },
      {
        id: 2,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076162049', '4548076162100', '4548076162148'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170648', '4548076170686', '4548076170723'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4547315579594', '4547315579648'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號、長褲XL號、運動鞋28.0cm<br />模特兒身高：175cm／外套L號、長版上衣L號、長褲L號、運動鞋25.0cm',
  },
  {
    id: 2,
    layout: '02',
    images: ['02-look-01', '02-look-02', '02-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076097365', '4548076097402', '4548076097440'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076169840', '4548076169888'],
          },
        ],
      },
      {
        id: 2,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076095026', '4548076095064'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076170938', '4548076170976'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／針織衫L號、長褲XL號<br />模特兒身高：175cm／針織衫L號、長褲L號',
  },
  {
    id: 3,
    layout: '01',
    images: ['03-look-01', '03-look-02', '03-look-01', '03-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076172062', '4548076172109'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4547315579471', '4547315579532'],
          },
        ],
      },
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170815'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4547315579594', '4547315579648'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／襯衫XL號、長褲XL號、運動鞋28.0cm<br />模特兒身高：175cm／襯衫L號、長褲70腰圍、運動鞋25.0cm',
  },
  {
    id: 4,
    layout: '03',
    images: ['04-look-01', '04-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076165590', '4548076165637'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076172062', '4548076172109'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4547315579471', '4547315579532'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號、襯衫XL號、長褲XL號、運動鞋28.0cm',
  },
  {
    id: 5,
    layout: '05',
    images: ['06-look-01'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076164203', '4548076164906'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號',
  },
  {
    id: 6,
    layout: '06',
    images: ['07-look-01'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076171706', '4548076171744', '4548076171782'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076169604', '4548076169642'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076170938', '4548076170976'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4547315579594', '4547315579648'],
          },
        ],
      },
    ],
    tips: '模特兒身高：175cm／大衣L號、外套L號、長褲L號、T 恤L號、運動鞋25.0cm',
  },
  {
    id: 7,
    layout: '03',
    images: ['08-look-01', '08-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723053778'],
          },
        ],
      },
    ],
    tips: '※未刊載之商品為示意搭配商品，或為日後預計販售之商品。',
  },
];

export const pickupData = [
  {
    id: 1,
    title: '棉帆布',
    img: 'pickup-1-hero',
    description:
      '採用高密度織法的帆布素材，兼具優異的耐久性與抗水性，同時保有良好的透氣性。隨著使用時間增加，布料會逐漸柔軟，色澤與質感也會自然融合，展現獨特的經年變化魅力。<br /><br />使用兩股粗線纏繞而成的雙股紗，高密度織製，並在布面進行微起毛處理，呈現長期使用後的復古帆布風格。<br /><br />織造、染色與加工皆在日本完成，是100%日本製（MADE IN JAPAN）布料。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4548076163176', '4548076163213'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4548076170044', '4548076170082', '4548076170129'],
      },
      {
        id: 3,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4548076169840', '4548076169888'],
      },
      {
        id: 4,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4548076170938', '4548076170976'],
      },
      {
        id: 5,
        current_index: 2,
        no_chips: false,
        tag: '',
        items: ['4548076170648', '4548076170686', '4548076170723'],
      },
    ],
  },
  {
    id: 2,
    title: '再生聚酯纖維丹寧布',
    img: '',
    description:
      '採用再生聚酯纖維製作，透過環保友善的工藝，開發出次世代丹寧布素材。<br />兼具丹寧布的耐用性與靛藍染色風格，同時採用深入纖維芯的染色技術，減少褪色問題。<br /><br />男裝經過弱水洗處理，呈現經典丹寧布自然的表情；<br />女裝則採未水洗設計，保留整潔的斜紋線條。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4548076165590', '4548076165637'],
      },
      {
        id: 2,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4548076172062', '4548076172109'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4548076170815'],
      },
    ],
  },
  {
    id: 3,
    title: '襯衫系列',
    img: '',
    description:
      '享受不同材質與穿著手感的襯衫系列。<br />適中厚度且有挺感的布料，呈現洗後自然的風格；<br />柔軟材質則展現平整細緻的表面與舒適的穿著感。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4548076162308', '4548076162346', '4548076162384'],
      },
      {
        id: 2,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4548076162049', '4548076162100', '4548076162148'],
      },
    ],
  },
];

export const lineupData = [
  {
    id: 1,
    heading: '男裝',
    productLists: [
      {
        title: '外套',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076163176', '4548076163213'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076164203', '4548076164906'],
          },
          {
            id: 3,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076165804', '4548076165842', '4548076165880'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076165590', '4548076165637'],
          },
        ],
      },
      {
        title: '上衣',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076097167', '4548076097204'],
          },
          {
            id: 2,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076106401', '4548076106500', '4548076106548'],
          },
          {
            id: 3,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076097365', '4548076097402', '4548076097440'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076119999', '4548076120049', '4548076120094'],
          },
          // {
          //   id: 5,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '預計四月上市',
          //   items: ['4548076121114', '4548076121169', '4548076121237'],
          // },
          {
            id: 6,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076106159', '4548076106197', '4548076106241'],
          },
          {
            id: 7,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076105107', '4548076105145', '4548076105985', '4548076878032'],
          },
          {
            id: 8,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076106708', '4548076106746', '4548076106784'],
          },
          {
            id: 9,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076841722', '4548076841760', '4548076841838'],
          },
        ],
      },
      {
        title: '褲子',
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076170044', '4548076170082', '4548076170129'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076169840', '4548076169888'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076097600', '4548076097648', '4548076097686'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170365'],
          },
          {
            id: 5,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076172062', '4548076172109'],
          },
          {
            id: 6,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076121985', '4548076122036', '4548076122081'],
          },
        ],
      },
      {
        title: '鞋款',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4547315579471', '4547315579532'],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    heading: '女裝',
    productLists: [
      {
        title: '外套',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076171706', '4548076171744', '4548076171782'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076166054', '4548076166962', '4548076169000'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076169604', '4548076169642'],
          },
          // {
          //   id: 4,
          //   current_index: 1,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4548076169123', '4548076169161'],
          // },
          {
            id: 5,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076094869', '4548076094906'],
          },
        ],
      },
      {
        title: '上衣',
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076094661', '4548076094708', '4548076094746'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076095026', '4548076095064'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076120612', '4548076120650', '4548076120759'],
          },
          {
            id: 4,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076119999', '4548076120049', '4548076120094'],
          },
          {
            id: 5,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076162582', '4548076162629', '4548076162667', '4548076162704'],
          },
          {
            id: 6,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076844792', '4548076844839'],
          },
          // {
          //   id: 7,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4548076835233', '4548076835271', '4548076835370'],
          // },
          {
            id: 8,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076835493', '4548076835592'],
          },
          // {
          //   id: 9,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4548076835752', '4548076835790', '4548076835837'],
          // },
          {
            id: 10,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4548076162308', '4548076162346', '4548076162384'],
          },
          {
            id: 11,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076162049', '4548076162100', '4548076162148'],
          },
        ],
      },
      {
        title: '褲子',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170938', '4548076170976'],
          },
          {
            id: 2,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076170648', '4548076170686', '4548076170723'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076120872', '4548076120919'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4548076170815'],
          },
          {
            id: 5,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4548076121985', '4548076122036', '4548076122081'],
          },
          // {
          //   id: 6,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '預計四月上市',
          //   items: ['4548076845379', '4548076845430', '4548076845492', '4548076845553'],
          // },
        ],
      },
      {
        title: '鞋款',
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4547315579594', '4547315579648'],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    heading: '服飾配件',
    productLists: [
      {
        title: '',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723053778'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723053785', '4550723053792'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723053815', '4550723053822'],
          },
          // {
          //   id: 4,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4550723087346', '4550723087407'],
          // },
          // {
          //   id: 5,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4550723087452', '4550723087506'],
          // },
          // {
          //   id: 6,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4550723053846', '4550723053853'],
          // },
          // {
          //   id: 7,
          //   current_index: 0,
          //   no_chips: false,
          //   tag: '',
          //   items: ['4550723056250', '4550723056267'],
          // },
        ],
      },
    ],
  },
];

export const featureData = {
  img: 'feature',
  heading1: '',
  heading2: '',
  title: '皮革低筒休閒鞋<br />（女鞋・男鞋）',
  description:
    '採用硫化工法製作的運動鞋。<br />鞋底為中空結構設計，兼具輕量感並能有效減緩行走時的衝擊。<br />為保護足部並維持穩定步伐，鞋頭與鞋跟部分設有鞋殼芯。<br />橡膠鞋帶設計，方便穿脫並提供舒適貼合的穿著感。',
  products: [
    {
      id: 1,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4547315579471', '4547315579532'],
    },
    {
      id: 2,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4547315579594', '4547315579648'],
    },
  ],
};

export const storiesData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/pdf/',
    img: 'story01.jpg',
    text: '穿搭型錄',
  },
  {
    id: 2,
    link: 'https://shop.muji.tw/sb/style/',
    img: 'story02.jpg',
    text: 'Stying Advisor 穿搭圖輯',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/styling_advisor/',
    img: 'story03.jpg',
    text: '服飾搭配諮詢服務',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/25aw/Lookbook-winter/',
    img: 'story04.jpg',
    text: '無印良品 2025｜冬季服飾穿搭',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/24aw/socks/',
    img: 'story05.jpg',
    text: '365天都想穿的襪款',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/feature/suitcase/',
    img: 'story06.jpg',
    text: '四輪硬殼止滑拉桿箱',
  },
];
